import * as React from "react";
const useKeyPress = function(targetKey, ref) {
  const [keyPressed, setKeyPressed] = React.useState(false);
  const downHandler = ({ code }) => {
    if (code === targetKey) {
      setKeyPressed(true);
    }
  };
  const upHandler = ({ code }) => {
    if (code === targetKey) {
      setKeyPressed(false);
    }
  };
  React.useEffect(() => {
    ref.current?.addEventListener("keydown", downHandler);
    ref.current?.addEventListener("keyup", upHandler);
    return () => {
      ref.current?.removeEventListener("keydown", downHandler);
      ref.current?.removeEventListener("keyup", upHandler);
    };
  }, []);
  return keyPressed;
};
export {
  useKeyPress as default
};
//# sourceMappingURL=use-key-press.js.map
